import LoginInfoModal from './LoginInfoModal';

export default LoginInfoModal;


// WEBPACK FOOTER //
// ./src/components/LoginInfoModal/index.jsx